import PropTypes from "prop-types";
import { useState } from "react";
import useSendinGuidelines from "../../../../hooks/useSendinGuidelines";
import Expandable from "../Expandable";
import { InfoIcon } from "../Icons.jsx";
import s from "./SendinGuidelines.module.css";

export default function SendinGuidelines({ influencerId }) {
  const { guidelinesHtml, isLoading } = useSendinGuidelines(influencerId);
  const [open, setOpen] = useState(false);
  const contentId = "sendin-guidelines-body";

  return (
    <section className={s.container} aria-label="Send-In Guidelines">
      <div className={s.header}>
        <InfoIcon className={s.icon} />
        <span className={s.label}>Important Send-In Guidelines</span>

        {isLoading ? (
          <div style={{ flex: 1 }}>
            <div className={s.skeletonBar} />
            <div className={s.skeletonBar} />
          </div>
        ) : (
          <button
            type="button"
            className={s.toggleBtn}
            aria-expanded={open}
            aria-controls={contentId}
            onClick={() => setOpen((v) => !v)}
          >
            {open ? "Close" : "Read"}
          </button>
        )}
      </div>

      {guidelinesHtml && (
        <Expandable open={open} id={contentId}>
          <div
            className={`${s.scrollArea} ${s.prose}`}
            tabIndex={open ? 0 : -1}
            role="region"
            aria-label="Guidelines content"
            aria-hidden={!open}
            dangerouslySetInnerHTML={{ __html: guidelinesHtml }}
          />
        </Expandable>
      )}
    </section>
  );
}

SendinGuidelines.propTypes = {
  influencerId: PropTypes.number.isRequired,
};
